import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env';
import { AnalyticsService, ReqService } from '@core/services';
import { dialogConfig } from '@modals/dialog.configure';
import { ModalRoomComponent } from '@modals/room/room.component';
import { MbDialog, MbBadgeModule, MbIconTextModule, MbIconModule } from '@am/moebius';
import { EllipsisPipe } from '@shared/pipes/ellipsis.pipe';
import { CustomTooltipDirective } from '@shared/pipes/custom-tooltip.directive';
import { NgIf, NgFor, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'room',
    templateUrl: './room.component.html',
    styleUrls: ['./room.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        CustomTooltipDirective,
        NgFor,
        MbBadgeModule,
        MbIconTextModule,
        MbIconModule,
        TitleCasePipe,
        EllipsisPipe,
    ],
})
export class RoomComponent implements OnInit {
  public readonly ROOM_NAME_WORDS_LIMIT = 6;

  @Input()
  mealPlan: string;
  @Input()
  latestRooms: number;
  @Input()
  index: number;
  @Input()
  room: any;
  @Input()
  numberRoom: any;
  @Input()
  roomsDetail: any;
  @Input()
  idHotel: string;
  @Input()
  isDisney: boolean;
  @Input()
  chain: string;
  @Input()
  isHomestay = false;
  @Input()
  isMobile = false;

  @Input()
  set offerCodes(value: string[]) {
    const uniqueCodes = new Set(value);
    this.offerCodesParsed = Array.from(uniqueCodes.values()).map(code =>
      code.replace('-', ''),
    );
  }

  public offerCodesParsed: string[] = [];
  public beds_info_filter = [];
  private sectionName: string;
  public detailRoom: { description?: string; name: string };
  public numberImagesSlider: number;
  public env: any = environment.environment;
  public roomDetail: any;
  public roomName: string;
  public isExperts: boolean;

  constructor(
    private analyticsService: AnalyticsService,
    private dialog: MbDialog,
    private readonly contextService: ReqService,
  ) {
    this.isExperts = this.contextService.isExperts();
  }

  ngOnInit() {
    this.sectionName = this.isDisney ? 'Disney' : 'Detail';
    this.numberImagesSlider = 1;
    this.detailRoom = this.getNameRoom(
      this.room.room_description && this.room.room_description.description
        ? this.room.room_description.description.split('_').shift()
        : '',
    );
    this.roomDetail = this.roomsDetail
      ? this.roomsDetail.find((roomDetail) => roomDetail.id === this.room.id)
      : '';


    this.beds_info_filter = this.removeDuplicates(this.room.bed_info);
    this.beds_info_filter.forEach((bed) => {
      bed.quantity = this.quatity(bed);
    });

    if (this.room && this.room.parsedName) {
      this.roomName = this.room.parsedName;
    } else {
      this.roomName = this.room.room_description.description;
    }
  }


  removeDuplicates(arr: []) {
    const filter = [];
    arr.forEach((bed) => {
      if (!this.find(filter, bed)) {
        filter.push(bed);
      }
    });
    return filter;
  }

  find(arr, value) {
    let find = false;
    arr.forEach((element) => {
      if (element.name === value.name) {
        find = true;
      }
    });
    return find;
  }

  quatity(bed_info) {
    let quantity = 0;
    this.room.bed_info.forEach((bed) => {
      if (bed.name === bed_info.name) {
        quantity += bed.quantity;
      }
    });

    return quantity;
  }

  public toggleModal(label: string) {
    if (!this.dialog.isAnyDialogOpen) {
      this.analyticsService.trackEvent({
        section: this.sectionName,
        action: `View ${this.sectionName} Room`,
        label: label,
      });
      const dialogData = {
        room: this.roomDetail,
        isDisney: this.isDisney,
      };
      this.dialog.open(ModalRoomComponent, {
        ...dialogConfig,
        closeBtn: true,
        size: 'lg',
        dialogData: dialogData,
      });
    }
  }

  /**
   * Get the name and description for room
   * @param roomDescription
   */
  private getNameRoom(roomDescription: string) {
    const res = roomDescription.split(/\(([^)]+)\)/);
    const hotelType: { description?: string; name: string } = {
      name: res[0].trim().split(':')[0],
    };
    if (res.length > 1) {
      hotelType.description = res[1].trim();
    }
    return hotelType;
  }
}
